import { css } from '@emotion/react/macro'
import { primaryBodyCss } from '../../../lib/styles/typography'

export const errorCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
`

export const descriptionCss = css`
  text-align: center;
  width: 395px;
  ${primaryBodyCss}
  margin-top: -7.5px;
`

export const linkCss = css`
  text-decoration: none;
`
